import React from 'react';
import { galleryImages } from '../data/mock';

const GallerySection = () => {
  return (
    <section id="equipo" className="bg-black py-20 lg:py-28">
      {/* Top gold line */}
      <div className="gold-divider mb-20" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            Nuestro <span className="gold-text">Equipo</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Profesionales comprometidos con tu bienestar
          </p>
          <div className="gold-divider w-32 mx-auto mt-8" />
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className={`animate-fade-in-up animate-delay-${(index + 1) * 100}`}
            >
              <div className="relative group">
                {/* Gold border frame */}
                <div className="absolute -inset-2 border border-[#D4AF37]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <div className="image-container overflow-hidden border border-[#D4AF37]/20">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-64 md:h-72 lg:h-80 object-cover"
                  />
                </div>

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <p className="text-white text-sm p-4">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
